import * as React from 'react';
import {
    Datagrid,
    Edit,
    NumberInput,
    BooleanInput,
    ReferenceManyField,
    TextInput,
    FormTab,
    SaveButton,
    Toolbar,
    FileInput,
    FileField,
    DateTimeInput,
    //TabbedForm,
    ReferenceField,
    FunctionField,
    DateField,
    DateInput,
    Labeled,
    useTranslate,
    BooleanField,
    useEditContext,
    TextField,
    useRecordContext,
    useGetIdentity,
    ArrayInput,
    SimpleFormIterator,
    FormDataConsumer,
} from 'react-admin';
import { TabbedForm, useCanAccess } from '@react-admin/ra-rbac';
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    number,
    email,
    regex,
    choices,
    useResourceContext,
} from 'react-admin';
import {
    Grid,
    Box,
    Typography,
    Stack,
    Button,
    Dialog,
    DialogActions,
    DialogContentText,
    DialogContent,
    DialogTitle,
    Link,
} from '@mui/material';

import {
    CustomSelectInput,
    CustomSelectArrayInput,
    CustomCheckboxGroupInput,
    CustomRadioButtonGroupInput,
    CustomJSONPretty,
    CustomTextField,
    CustomBulkDeleteButton,
    CustomBulkAddButton,
    CustomProductList,
    CustomNumberInput,
    CustomLogEventList,
    CustomUserLicenseByUserList,
    CustomUserSchoolList,
    CustomUserGroupList,
    CustomAddSubscriptionButton,
} from '../../controls';

import Merge from '../controls/Merge';

import {
    LibraryBooks,
    Article,
    Podcasts,
    Attachment,
    DataObject,
    TransferWithinAStation,
    History,
    Computer,
} from '@mui/icons-material';

import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';
import CustomStatistics from '../../controls/CustomStatistics';
import StatsWithIcon from '../../../components/statistics/controls/StatsWithIcon';
import SourceNameField from '../SourceNameField';
import SessionBadge from '../controls/SessionBadge';
import StaleBadge from '../controls/StaleBadge';
import { useState } from 'react';
import GdprDelete from '../controls/GdprDelete';
import ConditionalLoginField from '../ConditionalLoginField';
import ExtraMaterials from '../controls/Extramaterials';
import ConditionalMergeField from '../ConditionalMergeField';
import {
    SendMailApplication,
    SendMailLang,
    MailExample,
} from '../CreateUserDialogButton';
import { StatsTooltip } from '../../../components/statistics/common';
import PasswordResetLink from '../PasswordResetLink';

const getLastSegment = (url: string): string => {
    const segments = url.split('/');
    return segments.pop() || '';
};

const ValidateEmailUnicity = async value => {
    const userId = getLastSegment(window.location.href);
    console.log('userId', userId);
    console.log('ValidateEmailUnicity', value);

    if (email()(value) !== undefined) {
        return email()(value);
    }

    const response = await fetch(
        `${process.env.REACT_APP_INFRA_API}/student?filter={"q":"${value}","wholeword":true,"need_count":false,"not_id":"${userId}"}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        }
    );

    const users = await response.json();
    const isEmailUnique = users.length === 0;

    if (!isEmailUnique) {
        // You can return a translation key as well
        return 'notifications.EMAIL_ALREADY_USED';

        // Or even an object just like the other validators

        /*
        return {
            message: 'myroot.validation.email_already_used',
            args: { email: value },
        };
        */
    }
    return undefined;
};

const EditToolbar = () => {
    const resource = useResourceContext();
    const { canAccess } = useCanAccess({ action: 'write', resource });
    return (
        <Toolbar>
            {canAccess ? (
                <SaveButton />
            ) : (
                <Typography variant="body2" color="warning.main">
                    Sinulla ei ole muokkausoikeutta.
                </Typography>
            )}
        </Toolbar>
    );
};

const ApplicationForm = () => {
    const useEdit = useEditContext();
    //console.log('record', record);
    return (
        <RowForm defaultValues={{ user_guid: useEdit.record.guid }}>
            <CustomSelectInput
                resource="userapplication"
                source="application_guid"
                url="extralist/userapplication/applications"
                label=""
                validate={[required()]}
            />
            <BooleanInput
                resource="userapplication"
                source="isadmin"
                label=""
            />
            <CustomSelectInput
                resource="userapplication"
                source="public.userrights"
                url="extralist/userapplication/userrights"
                label=""
                showIfControl="application_guid"
                showIfValue="13b312b5-367c-4c74-bb77-bdb34df4e721"
                validate={[required()]}
            />
            <CustomSelectInput
                resource="userapplication"
                source="status"
                url="extralist/userapplication/statuses"
                label=""
                validate={[required()]}
            />
        </RowForm>
    );
};

const SchoolFormEdit = () => {
    const useEdit = useEditContext();
    //console.log('record', record);
    return (
        <RowForm
            defaultValues={{
                user_guid: useEdit.record.guid,
                group_guid: useEdit.record.group_guid,
            }}
        >
            {/* <CustomAutocompleteInput resource="usergroup" source="group_guid" url="extralist/schools" /> */}
            <TextField resource="usergroup" source="group.name" label="" />
            <DateField resource="usergroup" source="author.created" label="" />
            <CustomSelectInput
                resource="usergroup"
                source="public.materialcharge"
                label=""
                url="extralist/student/materialcharges"
            />
            <CustomSelectInput
                resource="usergroup"
                source="status"
                label=""
                url="extralist/student/statuses"
            />
        </RowForm>
    );
};

const ClassList = ({ canWrite }: { canWrite?: boolean | null }) => {
    const useRecord = useRecordContext();
    //console.log('useEditSchool', useRecord);
    return (
        <Edit
            resource="group"
            id={useRecord.group_guid}
            title=" "
            className="cgl-dg-edit"
        >
            <Grid container width={{ xs: '100%' }} spacing={2}>
                <Grid size={12}>
                    <CustomUserGroupList
                        disableSyncWithLocation
                        storeKey="customUserGroupList"
                        resource="usergroup"
                        params={{ user_guid: useRecord.user_guid }}
                        filter={{ type: 4 }}
                        customFilters={['parent_guid', 'user_guid']}
                        showExtra={['onlyactive']} //['onlyactive']
                        hideFields={[]} //['join', 'status', 'group_status', 'name', 'archived']
                        bulkActionButtons={false}
                        actions={canWrite ? undefined : false}
                    >
                        <span />
                    </CustomUserGroupList>
                </Grid>
            </Grid>
        </Edit>
    );
};

const StudentEdit = () => {
    const translate = useTranslate();

    const formatDate = dateString => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
        });
    };

    const [open, setOpen] = useState(false);
    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleContinue = () => {
        // Handle the continue action here

        handleCloseDialog();
    };

    const resource = useResourceContext();
    const { canAccess: canWrite } = useCanAccess({ action: 'write', resource });
    const { canAccess: canManageMerges } = useCanAccess({
        action: 'read',
        resource: 'merge',
    });
    const { canAccess: canResetPassword } = useCanAccess({
        action: 'reset_password',
        resource,
    });

    return (
        <Edit
            redirect={false}
            mutationMode="optimistic"
            queryOptions={{ refetchOnMount: 'always' }}
        >
            <TabbedForm toolbar={<EditToolbar />}>
                <FormTab
                    label="resources.student.tabs.profile"
                    icon={<Article />}
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <TextInput
                                resource="student"
                                source="public.firstname"
                                validate={[required(), minLength(2)]}
                                fullWidth
                            />
                            <TextInput
                                resource="student"
                                source="public.lastname"
                                validate={[required(), minLength(2)]}
                                fullWidth
                            />
                            <TextInput
                                resource="student"
                                source="public.email"
                                fullWidth
                                validate={value => {
                                    return ValidateEmailUnicity(value);
                                }}
                            />

                            <ArrayInput
                                resource="student"
                                source="public.emails"
                            >
                                <SimpleFormIterator
                                    disableReordering
                                    disableClear
                                    sx={{
                                        width: '100%',
                                    }}
                                >
                                    <TextInput
                                        source=""
                                        hiddenLabel
                                        helperText={false}
                                        validate={value => {
                                            return ValidateEmailUnicity(value);
                                        }}
                                    />
                                </SimpleFormIterator>
                            </ArrayInput>

                            <FormDataConsumer>
                                {({ formData, ...rest }) => {
                                    return formData &&
                                        formData?.username.startsWith('e') &&
                                        formData?.username?.length < 10 ? (
                                        <TextInput
                                            resource="student"
                                            source="username"
                                            fullWidth
                                            readOnly
                                        />
                                    ) : null;
                                }}
                            </FormDataConsumer>
                            <CustomSelectInput
                                resource="student"
                                source="status"
                                url="extralist/student/statuses"
                                parse={v => parseInt(v)}
                                fullWidth
                            />

                            {canResetPassword && <PasswordResetLink />}
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                            {canWrite && (
                                <Box
                                    display={{ xs: 'block', sm: 'flex' }}
                                    justifyContent="flex-end"
                                >
                                    <GdprDelete />
                                </Box>
                            )}

                            <Typography variant="subtitle1">
                                {translate(
                                    'resources.student.fields.group.valid'
                                )}
                            </Typography>
                            <Typography variant="body2">
                                {translate(
                                    'resources.student.fields.group.valid_desc'
                                )}
                            </Typography>
                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <DateInput
                                    resource="student"
                                    source="public.validfrom"
                                />
                            </Box>
                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <DateInput
                                    resource="student"
                                    source="public.validto"
                                />
                            </Box>

                            <BooleanInput
                                resource="student"
                                source="public.login_not_allowed"
                            />
                            <Stack direction="column">
                                <Stack direction="column">
                                    <BooleanInput
                                        resource="student"
                                        source="public.profile_locked"
                                    />
                                </Stack>
                                <Stack direction="row">
                                    <FormDataConsumer>
                                        {({ formData, scopedFormData }) => {
                                            return formData &&
                                                formData?.public
                                                    ?.profile_locked ? (
                                                <Stack direction="column">
                                                    <Stack
                                                        direction="row"
                                                        spacing={2}
                                                    >
                                                        <BooleanInput
                                                            resource="student"
                                                            label="resources.user.fields.public.profile_locked_message"
                                                            source="notification.profile_locked"
                                                        />

                                                        <FormDataConsumer>
                                                            {({
                                                                formData,
                                                                ...rest
                                                            }) =>
                                                                formData
                                                                    ?.notification
                                                                    ?.profile_locked ? (
                                                                    <>
                                                                        <SendMailLang source="notification.lang" />
                                                                        <SendMailApplication
                                                                            resource="student"
                                                                            source="notification.application"
                                                                            {...rest}
                                                                        />
                                                                    </>
                                                                ) : null
                                                            }
                                                        </FormDataConsumer>
                                                    </Stack>
                                                    <Stack direction="column">
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: 'text.secondary',
                                                            }}
                                                        >
                                                            {translate(
                                                                'resources.user.fields.public.profile_locked_description'
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            ) : null;
                                        }}
                                    </FormDataConsumer>
                                </Stack>
                                <FormDataConsumer>
                                    {({ formData, ...rest }) =>
                                        formData?.notification
                                            ?.profile_locked &&
                                        formData?.notification?.lang &&
                                        formData?.notification?.application ? (
                                            <Stack
                                                direction="column"
                                                sx={{ marginTop: 2 }}
                                            >
                                                <MailExample
                                                    lang={
                                                        formData?.notification
                                                            ?.lang
                                                    }
                                                    application={
                                                        formData?.notification
                                                            ?.application || ''
                                                    }
                                                    status={formData.status}
                                                    mailtemplate="UNLOCK_PROFILE"
                                                    {...rest}
                                                />
                                            </Stack>
                                        ) : null
                                    }
                                </FormDataConsumer>
                            </Stack>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2, marginTop: 2 }}
                            >
                                <Labeled>
                                    <SessionBadge
                                        source="last_login"
                                        options={{
                                            showTTL: true,
                                            showSessionDelete: true,
                                        }}
                                    >
                                        <ConditionalLoginField
                                            resource="student"
                                            showTime
                                            locales="fi-FI"
                                        />
                                    </SessionBadge>
                                </Labeled>
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.user.stale.title">
                                    <StaleBadge
                                        options={{
                                            showDetails: true,
                                            showToggle: true,
                                        }}
                                    >
                                        <span />
                                    </StaleBadge>
                                </Labeled>
                            </Box>

                            <Box display={{ xs: 'block', sm: 'flex' }}>
                                <ConditionalMergeField />
                            </Box>

                            <Box
                                display={{ xs: 'block', sm: 'flex' }}
                                sx={{ marginBottom: 2 }}
                            >
                                <Labeled label="resources.student.fields.services">
                                    <SourceNameField
                                        showRemove={!!canWrite}
                                        showDebug={!!canWrite}
                                    />
                                </Labeled>
                            </Box>

                            <Stack direction="row" spacing={4}>
                                <Box>
                                    <Labeled label="resources.student.fields.author.creator">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.creator"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="student"
                                                source="registered"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                                <Box>
                                    <Labeled label="resources.student.fields.author.modifier">
                                        <>
                                            <ReferenceField
                                                reference="user"
                                                source="author.modifier"
                                            >
                                                <FunctionField
                                                    render={record =>
                                                        `${record.public.firstname} ${record.public.lastname}`
                                                    }
                                                />
                                            </ReferenceField>
                                            <DateField
                                                resource="student"
                                                source="author.modified"
                                                showTime
                                                locales={'fi-FI'}
                                            />
                                        </>
                                    </Labeled>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormTab>
                <TabbedForm.Tab
                    label="resources.user.tabs.application"
                    icon={<Computer />}
                    path="palvelut"
                    name="palvelut"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <ReferenceManyField
                                reference="userapplication"
                                target="user_guid"
                            >
                                <EditableDatagrid
                                    bulkActionButtons={
                                        canWrite ? undefined : false
                                    }
                                    createForm={
                                        canWrite ? (
                                            <ApplicationForm />
                                        ) : undefined
                                    }
                                    editForm={<ApplicationForm />}
                                    noDelete={!canWrite}
                                    actions={canWrite ? undefined : false}
                                >
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="application_guid"
                                        label={translate(
                                            'resources.user.fields.application.name'
                                        )}
                                        url="extralist/userapplication/applications"
                                        showAsText={true}
                                    />
                                    <BooleanField
                                        resource="userapplication"
                                        source="isadmin"
                                        label={translate(
                                            'resources.user.fields.application.isadmin'
                                        )}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="public.userrights"
                                        label={translate(
                                            'resources.user.fields.application.role'
                                        )}
                                        url="extralist/userapplication/userrights"
                                        showAsText={true}
                                    />
                                    <CustomSelectInput
                                        resource="userapplication"
                                        source="status"
                                        label={translate(
                                            'resources.user.fields.application.status'
                                        )}
                                        url="extralist/userapplication/statuses"
                                        showAsText={true}
                                    />
                                </EditableDatagrid>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </TabbedForm.Tab>
                <FormTab
                    label="resources.student.tabs.schools_and_groups"
                    icon={<LibraryBooks />}
                    path="koulut_ja_ryhmat"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <ReferenceManyField
                                reference="usergroup"
                                target="user_guid"
                                filter={{ type: 2 }}
                            >
                                <EditableDatagrid
                                    bulkActionButtons={false}
                                    editForm={<SchoolFormEdit />}
                                    expand={<ClassList canWrite={!!canWrite} />}
                                    expandSingle={true}
                                    rowClick="expand"
                                    noDelete
                                    actions={canWrite ? undefined : false}
                                >
                                    {/* <CustomSelectInput resource="usergroup" source="group_guid" label={translate('resources.user.fields.group.name')} url="extralist/schools" filter="group_guid" showAsText={true} /> */}
                                    <FunctionField
                                        resource="usergroup"
                                        source="group.name"
                                        label={translate(
                                            'resources.user.fields.group.name'
                                        )}
                                        render={record => {
                                            return (
                                                <StatsTooltip
                                                    title={[
                                                        record?.author?.created
                                                            ? `Liitytty${record?.private?.services?.mpass ? ' (MPASS)' : ''}: ${formatDate(record.author.created)}`
                                                            : null,
                                                        record?.author?.modified
                                                            ? `Muokattu: ${formatDate(record.author.modified)}`
                                                            : null,
                                                    ]
                                                        .filter(Boolean)
                                                        .join('\n')}
                                                    followCursor
                                                    placement="top-start"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                padding:
                                                                    '12px 16px',
                                                                fontSize:
                                                                    '14px',
                                                                lineHeight: 1.4,
                                                                whiteSpace:
                                                                    'pre-line',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <span>
                                                        <Link
                                                            sx={{
                                                                textDecoration:
                                                                    record.group
                                                                        .status ===
                                                                    1
                                                                        ? 'line-through'
                                                                        : 'none',
                                                                color:
                                                                    record.group
                                                                        .status ===
                                                                    0
                                                                        ? '#000'
                                                                        : 'red',
                                                                '&:hover': {
                                                                    textDecoration:
                                                                        'underline',
                                                                },
                                                            }}
                                                            href={`#/school/${record.group_guid}`}
                                                            onClick={e =>
                                                                e.stopPropagation()
                                                            }
                                                            underline="hover"
                                                        >
                                                            {record.group.name}
                                                        </Link>
                                                    </span>
                                                </StatsTooltip>
                                            );
                                        }}
                                    />
                                    <DateField
                                        resource="usergroup"
                                        source="author.created"
                                        locales={'fi-FI'}
                                        label={translate(
                                            'resources.student.fields.school.registered'
                                        )}
                                    />
                                    <FunctionField
                                        resource="usergroup"
                                        label={translate(
                                            'resources.student.fields.materialcharge.title'
                                        )}
                                        render={function (
                                            record: any
                                        ): React.ReactNode {
                                            return record?.public
                                                ?.materialcharge === '1'
                                                ? translate(
                                                      'resources.student.fields.materialcharge.yes'
                                                  )
                                                : record?.public
                                                        ?.materialcharge === '0'
                                                  ? translate(
                                                        'resources.student.fields.materialcharge.no'
                                                    )
                                                  : translate(
                                                        'resources.student.fields.materialcharge.unknown'
                                                    );
                                        }}
                                    />
                                    <CustomSelectInput
                                        resource="usergroup"
                                        source="status"
                                        label={translate(
                                            'resources.user.fields.group.status'
                                        )}
                                        url="extralist/student/statuses"
                                        showAsText={true}
                                    />

                                    {/* <CustomSelectInput resource="usergroup" source="public.userrights" label={translate('resources.user.fields.group.role')} url="extralist/userapplication/userrights" showAsText={true} />
                                     */}
                                </EditableDatagrid>
                            </ReferenceManyField>
                        </Grid>
                    </Grid>
                </FormTab>
                <FormTab
                    label="resources.student.tabs.materials"
                    icon={<LibraryBooks />}
                    path="kaytossa"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            {canWrite && (
                                <>
                                    <Typography variant="h5" paragraph>
                                        Lisää tilaus
                                    </Typography>
                                    <CustomProductList
                                        resource="product"
                                        disableSyncWithLocation
                                        storeKey={false}
                                        customFilters={[
                                            'use_query_min_length',
                                            'use_v2',
                                        ]}
                                        showWarning={{
                                            applications: [
                                                'a7faf0f2-3cfc-4f62-9a77-aa75134ac5a4',
                                            ],
                                            checkStatus: true,
                                            targetPersons: ['student'],
                                        }}
                                        showExtra={['search', 'info']}
                                        sort={{ field: 'name', order: 'ASC' }}
                                        bulkActionButtons={
                                            <CustomAddSubscriptionButton />
                                        }
                                    >
                                        <span />
                                    </CustomProductList>
                                </>
                            )}
                        </Grid>

                        <Grid size={12}>
                            <CustomUserLicenseByUserList
                                resource="userlicense"
                                disableSyncWithLocation
                                customFilters={['user_guid']}
                                showExtra={['seasonFilter']}
                                hideFields={[]}
                                sort={{ field: 'product.name', order: 'ASC' }}
                                bulkActionButtons={
                                    canWrite ? (
                                        <CustomBulkDeleteButton />
                                    ) : (
                                        false
                                    )
                                }
                                showWarning={{
                                    applications: [
                                        'a7faf0f2-3cfc-4f62-9a77-aa75134ac5a4',
                                    ],
                                    checkStatus: true,
                                    targetPersons: ['student'],
                                }}
                            >
                                <span />
                            </CustomUserLicenseByUserList>
                        </Grid>
                        <Grid size={12}>
                            <ExtraMaterials resource="student" />
                        </Grid>
                    </Grid>
                </FormTab>
                {canManageMerges && (
                    <FormTab
                        label="resources.student.tabs.merge"
                        icon={<LibraryBooks />}
                        path="yhdistaminen"
                    >
                        <Grid container width={{ xs: '100%' }} spacing={2}>
                            <Grid size={12}>
                                <Merge />
                            </Grid>
                        </Grid>
                    </FormTab>
                )}
                <FormTab
                    label="resources.teacher.tabs.logs"
                    icon={<History />}
                    path="logit"
                >
                    <Grid container width={{ xs: '100%' }} spacing={2}>
                        <Grid size={12}>
                            <CustomStatistics
                                statisticKey="userEvents"
                                handler={StatsWithIcon}
                                mode="List"
                                from="30d"
                                limit={30}
                                exclude_search={['FORCE_LOGOUT', 'NO_INFRA']}
                                include_search={[]}
                                pagination={true}
                                showFilter={true}
                                include_source_fields={[
                                    'infra2.request_detail',
                                ]}
                            />
                        </Grid>
                    </Grid>
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

const redirect: any = () => {
    return window.location.hash.replace('#', '');
};

export default StudentEdit;
